module.exports = __webpack_public_path__ + "img/game7.3777db41.png";